import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { quickSearchDataAutomation } from "app/components/React/QuickSearch/dataAutomation";
import lighthouseGifUrl from "./images/lighthouse.gif";
import {
    QUICK_SEARCH_NO_RESULTS_GENERIC,
    QUICK_SEARCH_NO_RESULTS_HINT,
    QUICK_SEARCH_NO_RESULTS_TITLE,
} from "app/components/React/SearchAutocompleteWithTabs/texts";
import { translate } from "app/filters/i18nFilter";

const { carbon } = colorsPalettes;

/** Matches Figma “Lighthouse 1” frame (100 × 100). */
const LIGHTHOUSE_SIZE_PX = 100;

type QuickSearchTabEmptyStateProps = {
    dataAutomation?: string;
    /** Trimmed search text; when non-empty, title includes the query in quotes (Figma). */
    searchQuery?: string;
};

export const QuickSearchTabEmptyState = ({
    dataAutomation = quickSearchDataAutomation.tabEmptyDefault,
    searchQuery = "",
}: QuickSearchTabEmptyStateProps) => {
    const trimmed = searchQuery.trim();
    const hasQuery = trimmed.length > 0;

    const titleText = hasQuery
        ? translate(QUICK_SEARCH_NO_RESULTS_TITLE, { query: trimmed }, `No results found for "${trimmed}"`)
        : translate(QUICK_SEARCH_NO_RESULTS_GENERIC, {}, "No results found.");

    const hintText = translate(QUICK_SEARCH_NO_RESULTS_HINT, {}, "Try searching for something else.");

    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            gap="12px"
            width="100%"
            height="auto"
            data-automation={dataAutomation}
        >
            <img
                src={lighthouseGifUrl}
                width={LIGHTHOUSE_SIZE_PX}
                height={LIGHTHOUSE_SIZE_PX}
                alt=""
                aria-hidden
                data-automation={quickSearchDataAutomation.tabEmptyLighthouse}
            />
            <Stack
                gap="4px"
                alignItems="center"
                width="100%"
            >
                <Text
                    fontVariant="subtitle1"
                    color={carbon[500]}
                    textAlign="center"
                    width="100%"
                >
                    {titleText}
                </Text>
                <Text
                    fontVariant="body2"
                    color={carbon[400]}
                    textAlign="center"
                    width="100%"
                >
                    {hintText}
                </Text>
            </Stack>
        </Stack>
    );
};
